"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IconButtonWrapper = exports.IconButtonLink = exports.IconButtonExternalLink = exports.IconButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("./theme");
var _constants = require("../../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SIZE_MAP = {
  xs: '16',
  sm: '20',
  md: '24'
};
var IconButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var icon = props.icon,
    disabled = props.disabled,
    size = props.size,
    label = props.label,
    onClick = props.onClick,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type;
  return /*#__PURE__*/React.createElement(IconButtonWrapper, (0, _extends2["default"])({
    disabled: disabled,
    ref: ref,
    size: size || 'md',
    "aria-label": label,
    onClick: !disabled ? onClick : undefined,
    type: type
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(icon, {
    color: disabled ? _theme.IconButtonTheme.disabled.iconColor : _theme.IconButtonTheme.iconColor,
    size: size
  }));
});
exports.IconButton = IconButton;
IconButton.displayName = 'IconButton';
var IconButtonLink = function IconButtonLink(_ref) {
  var disabled = _ref.disabled,
    href = _ref.href,
    icon = _ref.icon,
    label = _ref.label,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    disabled: disabled,
    size: size || 'md',
    "aria-label": label,
    as: "a",
    href: disabled ? undefined : href,
    "aria-disabled": disabled ? true : undefined
  }, /*#__PURE__*/React.createElement(icon, {
    color: disabled ? _theme.IconButtonTheme.disabled.iconColor : _theme.IconButtonTheme.iconColor,
    size: size
  }));
};
exports.IconButtonLink = IconButtonLink;
IconButtonLink.displayName = 'IconButtonLink';
var IconButtonExternalLink = function IconButtonExternalLink(_ref2) {
  var disabled = _ref2.disabled,
    href = _ref2.href,
    icon = _ref2.icon,
    label = _ref2.label,
    size = _ref2.size;
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    disabled: disabled,
    size: size || 'md',
    "aria-label": label,
    as: "a",
    target: "_blank",
    rel: "noopener norefferer",
    href: href
  }, /*#__PURE__*/React.createElement(icon, {
    color: _theme.IconButtonTheme.iconColor,
    size: size
  }));
};
exports.IconButtonExternalLink = IconButtonExternalLink;
IconButtonExternalLink.displayName = 'IconButtonExternalLink';
var IconButtonWrapper = _styledComponents["default"].button.withConfig({
  displayName: "icon_buttons__IconButtonWrapper"
})(["", " display:inline-flex;padding:4px;flex-direction:row;justify-content:center;align-items:center;border-radius:50%;box-sizing:content-box;", " ", ""], function (props) {
  if (props.as && props.as !== 'button') {
    return;
  }
  return "\n      background-color: unset;\n      border: none;\n    ";
}, function (props) {
  return "\n    height: ".concat(SIZE_MAP[props.size], "px;\n    width: ").concat(SIZE_MAP[props.size], "px;\n  ");
}, function (props) {
  return props.disabled ? "\n    background: ".concat(_theme.IconButtonTheme.disabled.backgroundColor, ";\n  ") : "\n    &:hover,\n    &:focus-within {\n      background: ".concat(_theme.IconButtonTheme.hover.backgroundColor, ";\n    }\n\n    &:active {\n      background: ").concat(_theme.IconButtonTheme.active.backgroundColor, ";\n    }\n\n    cursor: pointer;\n  ");
});
exports.IconButtonWrapper = IconButtonWrapper;
var _default = IconButton;
exports["default"] = _default;